import React from 'react';
import './CurrentCommandComponent.css';
import { useCurrentCommandState } from '../../store/currentCommandStateStore';
import { emitter } from '../../input/AppEvents';
import { useTranslation } from 'react-i18next';
import { getCommandIconPath } from '../../commands/commandIcons';
import CommandIdEnum from '../../enums/CommandIdEnums';

// The command's toolbar icon in the accent colour, or a dot for commands without one
const CommandIcon = ({ commandId }: { commandId: CommandIdEnum }) => {
  const iconPath = getCommandIconPath(commandId);
  if (!iconPath) return <span className="command-status-dot" />;

  // Drawn as a mask, so the icon's lines take the accent colour whatever colour the image has
  const mask = `url("${iconPath}") center / contain no-repeat`;
  return <span className="command-icon" style={{ mask, WebkitMask: mask }} aria-hidden="true" />;
};

const CurrentCommandComponent = () => {

    const { t } = useTranslation();
    const { commandId, commandInfoVisible, commandNameResourceKey, commandPromptResourceKey, commandPromptParams, switchPlaneBtnVisible, onSwitchPlane,
          nextBtnVisible, nextBtnEnabled, nextBtnLabelResourceKey, onNext } = useCurrentCommandState();

  return (
    commandInfoVisible && commandId !== null &&
    <div className="command-container">
      <CommandIcon commandId={commandId} />
      <div className="command-info">
        <div className="command-name">{t(commandNameResourceKey)}</div>
        <div className="command-tooltip">{t(commandPromptResourceKey, commandPromptParams)}</div>
      </div>
      <div className="command-actions">
        {switchPlaneBtnVisible && onSwitchPlane &&
          <button className="command-btn command-btn-secondary" onClick={onSwitchPlane} title={t('command.switchInputPlaneTooltip')}>
            {t('command.switchInputPlane')}
          </button>
        }
        {nextBtnVisible && onNext &&
          <button className="command-btn command-btn-primary" onClick={onNext} disabled={!nextBtnEnabled}>
            {t(nextBtnLabelResourceKey)}
          </button>
        }
        <button className="command-btn command-btn-secondary"
                onClick={() => emitter.emit("commandStop", undefined)}>
          {t('common.cancel')}
        </button>
      </div>
    </div>
  );
};

export default CurrentCommandComponent;
